export const NEWSFEED_EVENTS = {
  NEWSFEED_POST_ADD_STARTED: 'NEWSFEED_POST_ADD_STARTED',
  NEWSFEED_POST_ADD_REQUESTED: 'NEWSFEED_POST_ADD_REQUESTED',
  NEWSFEED_POST_ADD_SUCCESS_ACKNOWLEDGED:
    'NEWSFEED_POST_ADD_SUCCESS_ACKNOWLEDGED',
  NEWSFEED_POST_ADD_FAILURE_ACKNOWLEDGED:
    'NEWSFEED_POST_ADD_FAILURE_ACKNOWLEDGED',
  NEWSFEED_POST_UPDATE_STARTED: 'NEWSFEED_POST_UPDATE_STARTED',
  NEWSFEED_POST_UPDATE_REQUESTED: 'NEWSFEED_POST_UPDATE_REQUESTED',
  NEWSFEED_POST_UPDATE_SUCCESS_ACKNOWLEDGED:
    'NEWSFEED_POST_UPDATE_SUCCESS_ACKNOWLEDGED',
  NEWSFEED_POST_UPDATE_FAILURE_ACKNOWLEDGED:
    'NEWSFEED_POST_UPDATE_FAILURE_ACKNOWLEDGED',
};

export const NEWSFEED_EVENT_SOURCE = {
  CREATE_POST: 'Create post',
  POST: 'Post',
  ADD_COMMENT: 'Add comment',
  REACT: 'React',
};

export const NEWSFEED_EVENT_SCREEN = {
  NEWSFEED: 'NEWS_FEED',
};

export const NEWSFEED_POST_TYPE = {
  POST: 'POST',
  COMMENT: 'COMMENT',
};
